module.exports = __webpack_public_path__ + "static/media/ko-to-tamo-scenario-2.afc89166.png";